import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ARTICLES_FEATURE_KEY, ArticlesState } from './articles.reducer';

// Lookup the 'Articles' feature state managed by NgRx
export const selectArticlesState =
  createFeatureSelector<ArticlesState>(ARTICLES_FEATURE_KEY);

export const selectArticle = () =>
  createSelector(selectArticlesState, (state: ArticlesState) => state.article);

export const selectClients = () =>
  createSelector(selectArticlesState, (state: ArticlesState) => state.clients);

export const selectClientsByArticleNumber = () =>
  createSelector(
    selectArticlesState,
    (state: ArticlesState) => state.clientsByArticleNumber,
  );

export const selectArticlesByClientId = () =>
  createSelector(
    selectArticlesState,
    (state: ArticlesState) => state.articlesByClientId,
  );

export const selectArticlesByClientIdLoading = () =>
  createSelector(
    selectArticlesState,
    (state: ArticlesState) => state.articlesByClientIdLoading,
  );

export const selectFilteredClients = () =>
  createSelector(
    selectArticlesState,
    (state: ArticlesState) => state.filteredClients,
  );

export const selectFilteredClientsLoading = () =>
  createSelector(
    selectArticlesState,
    (state: ArticlesState) => state.filteredClientsLoading,
  );
